import { render, staticRenderFns } from "./Mail.vue?vue&type=template&id=2144deea&scoped=true"
import script from "./Mail.vue?vue&type=script&lang=ts"
export * from "./Mail.vue?vue&type=script&lang=ts"
import style0 from "./Mail.vue?vue&type=style&index=0&id=2144deea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2144deea",
  null
  
)

export default component.exports